// extracted by mini-css-extract-plugin
module.exports = {"leftSection":"leftSection_leftSection__F1_Ns","address":"leftSection_address__2UMbg","socials":"leftSection_socials__3t6fN"};